import { createSlice } from "@reduxjs/toolkit";
import { fetchTaskerProfiles, getTaskerDetails, contactUs, getUserProfile } from "../thunks/userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {
    taskerProfiles: {
      profiles: [],
      pagination: {},
    },
    taskerProfile: {
      profile: {},
    },
    onAutoRemainders: true,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTaskerProfiles.fulfilled, (state, action) => {
      state.taskerProfiles.profiles = action.payload.data?.data || [];
      state.taskerProfiles.pagination = action.payload.data?.pagination || {};
    });

    builder.addCase(getTaskerDetails.fulfilled, (state, action) => {
      state.taskerProfile.profile = action.payload.data?.data[0] || {};
      // console.log("Fetching tasker details");
    });

    builder.addCase(getUserProfile.fulfilled, (state, action) => {
      state.onAutoRemainders = action.payload.data?.userData.onAutoRemainders;
      // console.log("Fetching user profile", action.payload.data);
    });

    builder.addCase(contactUs.fulfilled, (state, action) => {
      // console.log("Contact us success");
    });
  },
});

export default userSlice.reducer;
